export default __webpack_public_path__ + "static/media/IconDesc_C_Inv_Ramp_8x1_02.256.200c8063.png";